import { RoomInfo } from "../../types";

export class UploadVideoChunkRequestModel {
  /**ID файла */
  FileId!: number;
  /**ID видео */
  VideoId!: string;
  /**Чане */
  VideoChunk!: string;
  /**Последний чанк */
  IsLast: boolean = false;
  /**Комната (передается на последнем чанке) */
  Room?: RoomInfo;

  constructor(obj?: Partial<UploadVideoChunkRequestModel>) {
    Object.assign(this, obj);
  }
}
